<template>
    <div id="mainawards">
        <Nav currentpath="/awards">
            <h1>Awards</h1>

            <div class="award" v-for="a in awards" :key="a.title">
                <h2>{{a.title}}</h2>
                <p>{{a.text}}</p>
                <div class="links">
                    <a class="fakeicon" :href="e.link" v-for="e in a.actions" :key="e.link">{{e.name}}</a>
                </div>
            </div>
        </Nav>
    </div>
</template>

<script>
import Nav from "../../components/Nav.vue"

export default {
    name: 'Awards',
    components: {Nav},
    data() {
        return {
            awards: [
                {
                    "title": "EURO/ROADEF Challenge 2018",
                    "text": "Best team in Junior/Open source/Senior categories (among 64 registered teams)",
                    "actions": [
                        {
                            "name": "challenge website",
                            "link": "http://www.roadef.org/challenge/2018/en/finalResults.php"
                        },
                        {
                            "name": "ceremony",
                            "link": "https://www.euro-online.org/media_site/photos/Awards/2019/ROADEF2019winner2.jpg"
                        },
                    ],
                    // "interview": "https://www.youtube.com/watch?v=Xw6fA25MBz8&t=13s",
                    // "img": require('./img/challenge_roadef18.png'),
                },{
                    "title": "Metaheuristic summer school competition 2018",
                    "text": "Winner among 9 registered teams",
                    "actions": [
                        {
                            "name": "competition website",
                            "link": "http://195.201.24.233/mess2018/home.html"
                        },
                    ],
                },{
                    "title": "ACP summer school 2019 hackton",
                    "text": "Best team on easy and hard instances",
                    "actions": [
                        {
                            "name": "results website",
                            "link": "https://www.n-side.com/acp-summer-school-learn-constraint-programming/"
                        },
                    ],
                }
            ]
        }
    },
}
</script>

<style lang="scss">
    h1 {
        margin-bottom: 50px;
    }

    #mainawards {
        padding: 10px;

        .award {
            margin-bottom: 40px;

            p,h2 {
                margin: 5px;
            }
        }
    }
</style>
